import { useEffect, useState, type FormEvent } from "react";
import type { FooterSettings } from "@tih/shared";
import { FOOTER_SETTINGS_DEFAULT } from "@tih/shared";
import {
  ApiError,
  adminFetchSettingsFooter,
  adminPutSettingsFooter,
} from "../../../api/client";

export function AdminSettingsFooterPage() {
  const [form, setForm] = useState<FooterSettings>(FOOTER_SETTINGS_DEFAULT);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  useEffect(() => {
    adminFetchSettingsFooter()
      .then(setForm)
      .catch((e: unknown) =>
        setError(e instanceof Error ? e.message : String(e)),
      )
      .finally(() => setLoading(false));
  }, []);

  async function save(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setSuccess(null);
    try {
      const next = await adminPutSettingsFooter(form);
      setForm(next);
      setSuccess("Footer text saved.");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not save footer settings");
    } finally {
      setBusy(false);
    }
  }

  if (loading) {
    return <div style={{ opacity: 0.5 }}>Loading…</div>;
  }

  return (
    <div>
      <section className="admin-card">
        <h2 className="admin-card-title">Footer bottom bar</h2>
        <p className="admin-card-sub">
          Copyright line and scripture verse shown at the bottom of every page footer.
        </p>
        <form onSubmit={(e) => void save(e)} className="admin-blog-form">
          <div className="admin-blog-form-fields">
            <label>
              <span>Copyright line</span>
              <input
                type="text"
                value={form.copyright}
                onChange={(e) => setForm((f) => ({ ...f, copyright: e.target.value }))}
                disabled={busy}
                maxLength={300}
                placeholder={FOOTER_SETTINGS_DEFAULT.copyright}
                required
              />
            </label>
            <label>
              <span>Scripture verse</span>
              <input
                type="text"
                value={form.verse}
                onChange={(e) => setForm((f) => ({ ...f, verse: e.target.value }))}
                disabled={busy}
                maxLength={500}
                placeholder={FOOTER_SETTINGS_DEFAULT.verse}
                required
              />
            </label>
          </div>
          <div className="admin-card-row" style={{ marginTop: 16 }}>
            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy ? "Saving…" : "Save footer text"}
            </button>
          </div>
        </form>
      </section>

      {error && <div className="form-error">{error}</div>}
      {success && (
        <div className="form-success" style={{ padding: 12 }}>
          {success}
        </div>
      )}
    </div>
  );
}
